module.exports = __webpack_public_path__ + "img/bg_line_x_black.f9522a6d.jpg";